import React, { useEffect, useState } from "react";
import axios from "axios";
import { API_ENDPOINT } from "../../../../services/api/resources";
import classes from "./charts.module.css";
import { useSelector } from "react-redux";

const CountCards = () => {
  const Data = useSelector((state) => state.loginData.value);
  // const org_token = Data?.organization_token;

  const user_token = Data?.user?.token || Data?.user_token;

  const [invoiceData, setInvoiceData] = useState(null);

  const fetchInvoiceCount = async () => {
    try {
      const response = await axios.post(API_ENDPOINT.invoicecardcount, {
        org_token: user_token,
      });

      setInvoiceData(response?.data);
    } catch (error) {
      console.error("Invoice card count error:", error);
    }
  };

  useEffect(() => {
    fetchInvoiceCount();
  }, []);

  const cards = [
    { title: "Invoices", value: invoiceData?.invoiceCount, color: "blue" },
    { title: "E-Signed", value: invoiceData?.signedMerchant, color: "teal" },
    {
      title: "Pending E-Signature",
      value: invoiceData?.notSignedMerchant,
      color: "orange",
    },
    { title: "Approved", value: invoiceData?.approved, color: "purple" },
  ];

  return (
    <div className={classes.cardscontainer}>
      {cards.map((card, i) => (
        <div key={i} className={`${classes.card} ${classes[card.color]}`}>
          <h3 className={classes.cardtitle}>{card.title}</h3>
          <div className={classes.cardvalue}>{card.value}</div>
        </div>
      ))}
    </div>
  );
};

export default CountCards;
